import { Footer as FooterComponent } from "frno-react";
import { useLayout } from "../hooks/useLayout";

export default function Footer() {
  const { data: layout, isLoading, error } = useLayout();

  if (isLoading) {
    return null;
  }
  if (error) {
    console.error("Error loading layout:", error.message);
    return null;
  }

  return layout?.footer ? (
    <FooterComponent
      links={layout.footer.columns}
      social={layout.footer.social}
    />
  ) : null;
}
